module.exports = __webpack_public_path__ + "img/printer.df69c706.png";